"use strict";

exports.__esModule = true;
exports.dataHooks = exports.dataAttr = void 0;
var dataHooks = exports.dataHooks = {
  removeButton: 'tag-remove-button',
  text: 'tag-text',
  thumb: 'tag-thumb'
};
var dataAttr = exports.dataAttr = {
  SIZE: 'data-size',
  DISABLED: 'data-disabled',
  THEME: 'data-theme',
  HOVERABLE: 'data-hoverable',
  CLICKABLE: 'data-clickable'
};
//# sourceMappingURL=Tag.helpers.js.map